<template>
  <div class="slideshow-box">
    <a-carousel
      arrows
      dots-class="slick-dots slick-thumb"
      :before-change="beforeChange"
      autoplay
    >
      <!-- autoplay -->
      <div slot="customPaging" slot-scope="props"
          class="customPagingStyle">
        <a>
          <div v-if="getImgType(props.i).startsWith('video')" class="custom-video">
            <a-icon type="play-circle" class="play-icon" />
            <img :src="defaultImg" >
          </div>
          <img :src="getImgUrl(props.i)" />
        </a>
      </div>
      <div slot="prevArrow"
           class="custom-slick-arrow"
           style="left: 10px;zIndex: 1">
        <a-icon type="left" />
      </div>
      <div slot="nextArrow"
           class="custom-slick-arrow"
           style="right: 10px">
        <a-icon type="right" />
      </div>
      <div
        v-for="(item, index) in imgs"
        :key="index"
        @mouseenter="mouseenter"
        @mouseleave="mouseleave"
        @mousemove="mousemove"
      >
        <video v-if="item.fileType && item.fileType.startsWith('video')" controls="controls" :src="item.filePath"/>
        <img v-else :src="item.filePath || ''" />
      </div>
    </a-carousel>
      <div
        v-show="showSquare"
        class="square"
        :style="{left:offsetX + 'px', top: offsetY + 'px'}"
      />
  </div>
</template>

<script>
import defaultImg from '@/assets/img/pic-cangku-default.png';

export default {
  props: {
    files: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      imgs: [],
      defaultImg,
      offsetX: 0,
      offsetY: 0,
      showSquare: false,
      imgurl: '',
      fileType: '',
    }
  },
  watch: {
    files(val = []) {
      const imgs = val
      console.log(val,'val');
      // const imgs =  val.filter((v) =>  v.fileType.startsWith('image'))
      if (!imgs.length) {
        imgs.push({
          filePath: [defaultImg],
        })
      }
      this.fileType =imgs[0]?.fileType || ''
      this.$emit('imgurl', imgs[0]?.filePath[0] || defaultImg)
      this.imgs = imgs.map(item=>({...item,filePath:item.filePath[0]}))
    }
  },
  methods: {
    changeAuto(val) {
      this.autoPlay = val
    },
    getImgUrl(i) {
      return this.imgs[i]?.filePath || defaultImg
    },
    getImgType(i) {
      return this.imgs[i]?.fileType || ''
    },
    mousemove(e) {
      const maxX = e.target.width - 180
      const maxY = e.target.height - 200
      this.offsetX = Math.min(Math.max(0, (e.offsetX - 180 / 2)), maxX)
      this.offsetY = Math.min(Math.max(0, (e.offsetY - 200 / 2)), maxY)
      this.$emit('toMove', this.offsetX, this.offsetY)
    },
    mouseenter() {
      if (this.fileType.startsWith('video')) {
        return
      }
      this.showSquare = true
      this.$emit('mouseenter')
    },
    mouseleave() {
      this.showSquare = false
      this.$emit('mouseleave')
    },
    beforeChange(from,to){
      this.fileType = this.imgs[to]?.fileType || ''
      this.$emit('imgurl', this.imgs[to]?.filePath || defaultImg)
    }
  },
}
</script>

<style lang="less" scoped>
.slideshow-box {
  height: 100%;
  position: relative;
  .square {
    display: inline-block;
    position: absolute;
    width: 180px !important;
    height: 200px !important;
    background: #06B880;
    opacity: 0.4;
    cursor: move;
    pointer-events:none;
  }
  .banner-box {
    overflow-x: none;
  }
  .slick-slide {
    opacity: 0;
    img {
      cursor: crosshair;
    }
  }
  .slick-slide.slick-active {
    opacity: 1;
    z-index: 999;
  }
  .custom-video {
    position: relative;
    height: 100%;
    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 111;
      font-size: 26px;
      transform: translate(-50%, -50%);
    }
  }
}
// 底部图片
.ant-carousel /deep/ .slick-thumb {
  display: block;
  height: 80px;
  bottom: -100px;
  width: calc(100% - 100px);
  left: 50%;
  transform: translateX(-50%);
}
.ant-carousel /deep/ .slick-thumb li {
  width: 80px;
  height: 80px;
}
.ant-carousel /deep/ .slick-thumb li img {
  width: 100%;
  height: 100%;
  // filter: grayscale(50%);
  opacity: 0.6;
  &:hover {
    // filter: grayscale(0%);
    opacity: 1;
  }
}
.ant-carousel /deep/ .slick-thumb li.slick-active img {
  // filter: grayscale(0%);
  opacity: 1;
}
// 左右
.ant-carousel /deep/ .custom-slick-arrow {
  top: 42%;
  width: 47px;
  height: 92px;
  font-size: 20px;
  color: #fff;
  background: rgba(0,0,0,0.3);
  margin-top: 0;
  line-height: 80px;
  text-align: center;
  z-index: 20;
  user-select: none;
  border-radius: 4px;
  margin: 0 27px;
  z-index: 100 !important;
}
.ant-carousel /deep/ .custom-slick-arrow:before {
  display: none;
}
.ant-carousel /deep/ .custom-slick-arrow:hover {
  background: rgba(0,0,0,0.6);
}
.customPagingStyle{
  height: 100px;
}
</style>